import { ButtonGroup, Button, Box, Grid2 as Grid, Tooltip } from "@mui/material"
import { cow_type_sublist } from "../definitions/cow"

export const CowtypeButton = ({ cow_type, setValue }) => {
    return (

        <ButtonGroup size="small">
            {cow_type_sublist.map((e, k) => (
                <Button key={k} variant={cow_type === e.id ? 'contained' : 'outlined'} onClick={() => setValue(e.id)}>
                    <Box sx={{ backgroundColor: e.color, mr: 1, borderRadius: 5, minWidth: 10 }}>&nbsp;&nbsp;</Box>
                    {e.label}
                </Button>

            ))}
        </ButtonGroup>
    )
}
export const CowtypeChip = ({ cow_type }) => {
    return (

        cow_type_sublist.filter(e => cow_type === e.id).map((e, k) => (
            <Grid key={k} container>

                <Box sx={{ backgroundColor: e.color, mr: 1, borderRadius: 5, minWidth: 10 }}>&nbsp;&nbsp;</Box>
                {e.label}
            </Grid>

        ))
    )
}

export const CowtypeBadge = ({ cow_type }) => {

    if (cow_type === 'red') {
        return (
            <Tooltip placement="right" title="red holstein">
                <Box sx={{ backgroundColor: 'red', minWidth: '10px', mr: 0.2 }}>&nbsp;</Box>
            </Tooltip>
        )

    } else if (cow_type === 'black'){
        return (
            <Tooltip placement="right" title="holstein">
                <Box sx={{ backgroundColor: 'black', minWidth: '10px', mr: 0.2 }}>&nbsp;</Box>
            </Tooltip>
        )

    }else{
        return <></>
    }
}